<div class="container-fluid">
    <div class="row">
        <div class="col-md-2">
            <nj-form-item [hasError]="(this.Instruction.issuedFrom ?? '') == ''" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventStartTime" [isRequired]="true">
                <input type="date" id="EventStartTime" njFormField [(ngModel)]="Instruction.issuedFrom" (ngModelChange)="onDatesChange()" />
                <ng-container njFormLabel>Issued From</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="(this.Instruction.issuedFrom ?? '') == ''" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventEndTime" [isRequired]="true">
                <input type="date" id="EventEndTime" njFormField [(ngModel)]="Instruction.issuedTo" (ngModelChange)="onDatesChange()"/>
                <ng-container njFormLabel>Issued To</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
            <div [style]="'color:red'">{{DateRangeError}}</div>
        </div>
        <div class="col-md-6">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="dateComments" [isRequired]="false">
                <input type="text" id="dateComments" njFormField [(ngModel)]="Instruction.dateComment" />
                <ng-container njFormLabel>Date Comments</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="subject" [isRequired]="true">
                <input type="text" id="subject" njFormField [(ngModel)]="Instruction.subject" />
                <ng-container njFormLabel>Subject</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="Details">
                <textarea id="Details" [(ngModel)]="Instruction.details" njFormField maxlength="1000"></textarea>
                <ng-container njFormLabel>Details</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12" [style]="'margin-top: 10px;'">
            <table border="1" [cellSpacing]="0" [cellPadding]="2" [width]="'100%'">
                <thead>
                    <tr>
                        <th>D-2 Forecast Index</th>
                        <th>Argus</th>
                        <th>LEBA (8-9)</th>
                        <th>LEBA (all Day)</th>
                        <th>N2EX</th>
                        <th>PX</th>
                    </tr>
                </thead>
                <tbody>
                    @for(d2Forecast of Instruction.forecasts; track d2Forecast; let ix = $index;){
                    <tr>
                        <td>
                            {{DateFormatHelper.GetDisplayDateOnly(d2Forecast.forecastDate)}}
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="false" iconName=""
                                [inputId]="'foreCastIndex' + ix.toString()" [isRequired]="true">
                                <input type="number" [id]="'foreCastIndex' + ix.toString()" [(ngModel)]="d2Forecast.argus" njFormField />
                                <ng-container njFormLabel>Argus</ng-container>
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="false" iconName=""
                                [inputId]="'leba_8_9' + ix.toString()" [isRequired]="true">
                                <input type="number" [id]="'leba_8_9' + ix.toString()" [(ngModel)]="d2Forecast.leba_8_9" njFormField />
                                <ng-container njFormLabel>Leba 8-9</ng-container>
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td> 
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="false" iconName=""
                                [inputId]="'leba_allday' + ix.toString()" [isRequired]="true">
                                <input type="number" [id]="'leba_allday' + ix.toString()" [(ngModel)]="d2Forecast.leba_all" njFormField />
                                <ng-container njFormLabel>Leba All Day</ng-container>
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td> 
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="false" iconName=""
                                [inputId]="'N2EX' + ix.toString()" [isRequired]="true">
                                <input type="number" [id]="'N2EX' + ix.toString()" [(ngModel)]="d2Forecast.n2EX" njFormField />
                                <ng-container njFormLabel>N2EX</ng-container>
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td> 
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="false" iconName=""
                                [inputId]="'pX' + ix.toString()" [isRequired]="true">
                                <input type="number" [id]="'pX' + ix.toString()" [(ngModel)]="d2Forecast.pX" njFormField />
                                <ng-container njFormLabel>PX</ng-container>
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class="row" [style]="'margin-top: 20px;'">
        Attachments
    </div>
    <div class="row" [style]="'margin-bottom: 5px;'">
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="file" [isRequired]="true">
                <input type="file" id="file" njFormField (change)="onFileSelected($event)" />
                <ng-container njFormLabel>File</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2" [style]="'margin-top: 10px;'">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="AddFile()">
                Add File
            </nj-button>
        </div>
    </div>
    <div class="row">
        <table id="Attachments" class="nj-table nj-table--hover nj-table--striped nj-cursor">
            <thead>
                <tr [style]="'background-color: #d8d8d8'">
                    <th>File</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (file of Instruction.files; track file; let ix = $index) {
                <tr>
                    <td>{{file.fileName}}</td>
                    <td>
                        <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                            (buttonClick)="RemoveFile(ix)">
                            Delete
                        </nj-button>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    <div class="row">
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="SaveInstruction()">
                Save
            </nj-button>
        </div>
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                [style]="'margin-top: 10px;'" (buttonClick)="Cancel()">
                Cancel
            </nj-button>
        </div>
    </div>
</div>